// src/components/admin/blockEditors/VideoBlockEditor.tsx
import React, { useState, useEffect } from 'react';
import { VideoBlock } from '../../../types/contentBlocks.types';
import './BlockEditors.css';

interface VideoBlockEditorProps {
    block: VideoBlock;
    onChange: (block: VideoBlock) => void;
}

export const VideoBlockEditor: React.FC<VideoBlockEditorProps> = ({ block, onChange }) => {
    const [url, setUrl] = useState(block.data.url);
    const [title, setTitle] = useState(block.data.title || '');
    const [description, setDescription] = useState(block.data.description || '');

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            onChange({
                ...block,
                data: { url, title, description }
            });
        }, 500);

        return () => clearTimeout(timeoutId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, title, description]);

    const getYouTubeId = (url: string): string | null => {
        const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/ |.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/;
        const match = url.match(regex);
        return match ? match[1] : null;
    };

    const videoId = getYouTubeId(url);

    return (
        <div className="be-container">
            <div className="be-form-group">
                <label className="be-label">URL do YouTube</label>
                <input
                    type="text"
                    className="be-input"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    placeholder="https://www.youtube.com/watch?v=..."
                />
                <p className="be-hint">
                    Cole o link completo do YouTube (formatos aceitos: youtube.com/watch?v= ou youtu.be/)
                </p>
            </div>

            <div className="be-form-group">
                <label className="be-label">Título (opcional)</label>
                <input
                    type="text"
                    className="be-input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Ex: Veja como são os flashcards"
                />
            </div>

            <div className="be-form-group">
                <label className="be-label">Descrição (opcional)</label>
                <textarea
                    className="be-textarea"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    rows={3}
                    placeholder="Breve descrição do vídeo..."
                />
            </div>

            {/* Preview */}
            {videoId && (
                <div className="be-preview-section">
                    <label className="be-label">Preview</label>
                    <div className="be-video-preview">
                        <iframe
                            src={`https://www.youtube.com/embed/${videoId}`}
                            title="Preview"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{
                                width: '100%',
                                height: '315px',
                                borderRadius: '8px'
                            }}
                        />
                    </div>
                </div>
            )}

            {url && !videoId && (
                <div className="be-error-box">
                    ⚠️ URL inválida. Verifique o link do YouTube.
                </div>
            )}
        </div>
    );
};